export default __webpack_public_path__ + "static/media/main.74e14c13.svg";